import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@mantine/core";
import { Link, Location } from "@reach/router";

const useStyles = makeStyles(
  (theme) =>
    console.log(theme) || {
      nav: {
        alignItems: "center",
        backgroundColor: theme.app.background[1],
        borderBottom: `1px solid ${theme.app.borderColorLight}`,
        display: "flex",
        height: "64px",
        left: 0,
        padding: "0 16px",
        "@media(max-width: 768px)": {
          display: "none",
        },
      },
      navButton: {
        color: theme.app.labelColor,
      },
      activeNav: {
        color: theme.palette.primary.dark,
        pointerEvents: "none",
      },
    }
);

const Nav = () => {
  const { language, config, url } = useSelector((state) => ({
    config: state.infrastructure.config,
    language: state.language,
    url: state.infrastructure.url,
  }));
  const classes = useStyles();
  return (
    <nav className={classNames(classes.nav, "Nav-container")}>
      <Location>
        {({ location }) => (
          <>
            <Button
              className={classNames(
                location.pathname === `${process.env.PUBLIC_URL}/`
                  ? classes.activeNav
                  : classes.navButton,
                "Nav__link-button"
              )}
              color="dark"
              component={Link}
              variant="subtle"
              to={`${process.env.PUBLIC_URL}/`}
            >
              {(language.Nav && language.Nav.Home) || "Hem"}
            </Button>
            {config.registerMember && (
              <Button
                className={classNames(
                  location.pathname ===
                    `${process.env.PUBLIC_URL}/registermember`
                    ? classes.activeNav
                    : classes.navButton,
                  "Nav__link-button"
                )}
                variant="subtle"
                color="dark"
                component={Link}
                to={`${process.env.PUBLIC_URL}/registermember`}
                disabled={url}
              >
                {(language.Nav && language.Nav.Register_Member) ||
                  "Registrera medlem"}
              </Button>
            )}
            {config.registerTicket && (
              <Button
                className={classNames(
                  location.pathname ===
                    `${process.env.PUBLIC_URL}/registerticket`
                    ? classes.activeNav
                    : classes.navButton,
                  "Nav__link-button"
                )}
                variant="subtle"
                color="dark"
                component={Link}
                to={`${process.env.PUBLIC_URL}/registerticket`}
                disabled={url}
              >
                {(language.Nav && language.Nav.Register_Ticket) ||
                  "Aktivera årskort"}
              </Button>
            )}

            {!config.hideNewPassword && (
              <Button
                className={classNames(
                  location.pathname ===
                    `${process.env.PUBLIC_URL}/requestpassword`
                    ? classes.activeNav
                    : classes.navButton,
                  "Nav__link-button"
                )}
                variant="subtle"
                color="dark"
                component={Link}
                to={`${process.env.PUBLIC_URL}/requestpassword`}
              >
                {(language.Nav && language.Nav.Request_Password) ||
                  "Nytt lösenord"}
              </Button>
            )}
          </>
        )}
      </Location>
    </nav>
  );
};

export default Nav;
